import {
    type FC,
    memo
} from "react";
import type IDataTableSelectColumnProps from "./type";
import type {
    DataTableSelectCellProps
} from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize
} from "../../../../core/hooks";
import {
    useDataTableSelectionContext,
    useDataTableContext
} from "../../context";
import CheckBox from "../../../checkBox";
import Table from "../../../table";

export const DataTableSelectCell = memo<DataTableSelectCellProps>(({
    customTheme,
    isChecked,
    isSticky,
    rowId
}) => {
    const context = useDataTableContext({
        part: "SelectColumn"
    });

    const {
        localize
    } = NCoreUIKitLocalize.useContext(context?.customLocalize);

    const {
        container: containerDynamicStyle
    } = useStyles({
        selectWidth: context?.selectWidth ?? 0
    });

    if(!context) {
        return null;
    }

    const row = context.rows.find((item) => item.id === rowId);

    return <Table.Cell
        customTheme={customTheme ?? context.customTheme}
        style={[
            stylesheet.container,
            containerDynamicStyle
        ]}
        isSticky={isSticky}
        isShrink={true}
    >
        <CheckBox
            accessibilityLabel={localize("data-table-select-row", [
                row?.label ?? rowId
            ])}
            customTheme={customTheme ?? context.customTheme}
            onPress={() => context.handleToggleRow(rowId)}
            isChecked={isChecked}
        />
    </Table.Cell>;
});

const DataTableSelectColumn: FC<IDataTableSelectColumnProps> = ({
    customTheme,
    isSticky,
    rowId
}) => {
    const context = useDataTableContext({
        part: "SelectColumn"
    });

    const selectionContext = useDataTableSelectionContext();

    const {
        localize
    } = NCoreUIKitLocalize.useContext(context?.customLocalize);

    const {
        container: containerDynamicStyle
    } = useStyles({
        selectWidth: context?.selectWidth ?? 0
    });

    if(!context || !selectionContext) {
        return null;
    }

    if(rowId !== undefined) {
        return <DataTableSelectCell
            isChecked={selectionContext.selectedRowIds.includes(rowId)}
            customTheme={customTheme}
            isSticky={isSticky}
            rowId={rowId}
        />;
    }

    const currentTheme = customTheme ?? context.customTheme;

    return <Table.Head
        customTheme={currentTheme}
        style={[
            stylesheet.container,
            containerDynamicStyle
        ]}
        isSticky={isSticky}
        isShrink={true}
    >
        {
            context.selectionBehaviour === "multiple" ?
                <CheckBox
                    isChecked={selectionContext.isAllSelected || selectionContext.isSomeSelected}
                    accessibilityLabel={localize("data-table-select-page")}
                    isIndeterminate={selectionContext.isSomeSelected}
                    onPress={context.handleTogglePage}
                    customTheme={currentTheme}
                />
            :
                null
        }
    </Table.Head>;
};
export default DataTableSelectColumn;
